import { useState } from 'react'

export const InquiryState = () => {
    const [inquiry, setInquiry] = useState({
        id: null,
        list: [],
        form: {
            toggled: false,
            id: null,
            data: null
        }

    })
    
    return {
        inquiry: {data: inquiry, set: setInquiry}
        
    }
}
